/*global Materialize*/
/*eslint no-undef: ["error", { "typeof": true }] */

import React, { Component } from "react";
import { connect } from "react-redux";
import { fetch } from "@fyresite/fetch";

import TextInput from "@fyresite/react-textinput";
import Button from "../../../components/Button";
import moment from "moment";
class EditMember extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            member: {},
            firstName: {
                value: "",
                valid: "",
            },
            lastName: {
                value: "",
                valid: "",
            },
            dateOfBirth: {
                value: "",
                valid: "",
            },
            // gender: {
            //   value: '',
            //   valid: ''
            // },
            nordIdentifier: {
                value: "",
                valid: "",
            },
        };
        this.handleInputKeyPress = this.handleInputKeyPress.bind(this);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleInputKeyPress);
    }
    componentWillMount() {
        this.getMember();
        document.addEventListener("keydown", this.handleInputKeyPress);
    }
    handleInputKeyPress(e) {
        if (e.key.toLowerCase() === "enter") {
            this.handleSubmit(e);
        }
    }

    getMember() {
        fetch(`/api/v1/member/read/${this.props.match.params.id}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        })
            .then((res) => {
                return res.json();
            })
            .then((json) => {
                if (json.code === 200) {
                    let member = json.result.member;

                    let state = JSON.parse(JSON.stringify(this.state));
                    state.member = member;

                    for (var x = 0; x < Object.keys(state).length; x++) {
                        let key = Object.keys(state)[x];

                        if (member[key]) {
                            state[key].value = member[key];
                            state[key].valid = true;
                        }
                    }

                    this.setState((prevState, props) => {
                        return state;
                    });
                } else {
                    Materialize.toast(
                        `Error occured, ${json.message}`,
                        4000,
                        "red"
                    );
                }
            })
            .catch((err) => {
                Materialize.toast(`Fetch error, ${err}`, 4000, "red");
            });
    }

    onChange(field, e, inputState) {
        let state = Object.assign({}, this.state);

        state[field] = Object.assign({}, state[field], inputState);

        this.setState((prevState, props) => {
            return state;
        });
    }

    onRadioChange(field, e) {
        let value = e.target.value;
        let stateField = this.state[field];

        stateField.value = value;
        stateField.valid = true;

        this.setState((prevState, props) => {
            return {
                [field]: stateField,
            };
        });
    }

    handleSubmit(e) {
        e.preventDefault();

        let state = JSON.parse(JSON.stringify(this.state));
        delete state.member;
        for (var x = 0; x < Object.keys(state).length; x++) {
            let key = Object.keys(state)[x];
            if (!state[key].valid) {
                Materialize.toast(
                    `Please make sure that the ${key} is valid`,
                    4000,
                    "red"
                );
                return;
            }
        }

        fetch(`/api/v1/member/update/${this.state.member.id}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                firstName: this.state.firstName.value,
                lastName: this.state.lastName.value,
                dateOfBirth: this.state.dateOfBirth.value,
                gender: "X",
                nordIdentifier: this.state.nordIdentifier.value,
            }),
        })
            .then((res) => {
                return res.json();
            })
            .then((json) => {
                if (json.code === 200) {
                    Materialize.toast("Member was updated", 4000);
                } else {
                    Materialize.toast(
                        `Error Occured, ${json.message}`,
                        4000,
                        "red"
                    );
                }
            })
            .catch((err) => {
                Materialize.toast(`Fetch error, ${err}`, 4000);
            });
    }

    render() {
        return (
            <div className="edit-member card-wrapper">
                <div className="card-container">
                    <div className="form-card card z-depth-5" ref="form-card">
                        <div className="card-content">
                            <span className="card-title">Edit Member</span>
                            <form
                                onSubmit={this.handleSubmit.bind(this)}
                                className="left-align"
                                noValidate
                            >
                                <TextInput
                                    ref={(input) => (this.firstName = input)}
                                    className=""
                                    inputClassName=""
                                    id="firstName"
                                    label="First Name"
                                    error="Please enter a first name"
                                    type="text"
                                    onChange={this.onChange.bind(
                                        this,
                                        "firstName"
                                    )}
                                    value={this.state.firstName.value}
                                    valid={this.state.firstName.valid}
                                    validator={(val) => {
                                        return val.length > 1;
                                    }}
                                />

                                <TextInput
                                    ref={(input) => (this.lastName = input)}
                                    className=""
                                    inputClassName=""
                                    id="lastName"
                                    label="Last Name"
                                    error="Please enter a last name"
                                    type="text"
                                    onChange={this.onChange.bind(
                                        this,
                                        "lastName"
                                    )}
                                    valid={this.state.lastName.valid}
                                    value={this.state.lastName.value}
                                    validator={(val) => {
                                        return val.length > 1;
                                    }}
                                />

                                <TextInput
                                    ref={(input) => (this.dateOfBirth = input)}
                                    className=""
                                    inputClassName=""
                                    id="dateOfbirth"
                                    label="Date Of Birth"
                                    error="Please enter a Date of Birth"
                                    type="date"
                                    onChange={this.onChange.bind(
                                        this,
                                        "dateOfBirth"
                                    )}
                                    value={moment(this.state.dateOfBirth.value)
                                        .utc()
                                        .format("YYYY-MM-DD")}
                                    valid={this.state.dateOfBirth.valid}
                                    validator={(val) => {
                                        return val.length > 1;
                                    }}
                                />

                                {/*<div>
                                    <p>{"Gender"}</p>
                                    <div className="radios">
                                        <div>
                                            <input
                                                type="radio"
                                                id={`gender-male`}
                                                checked={
                                                    this.state.gender.value ===
                                                    "Male"
                                                }
                                                value={"Male"}
                                                onChange={this.onRadioChange.bind(
                                                    this,
                                                    "gender"
                                                )}
                                            />
                                            <label htmlFor={`gender-male`}>
                                                Male
                                            </label>
                                        </div>
                                        <div>
                                            <input
                                                type="radio"
                                                id={`gender-female`}
                                                checked={
                                                    this.state.gender.value ===
                                                    "Female"
                                                }
                                                value={"Female"}
                                                onChange={this.onRadioChange.bind(
                                                    this,
                                                    "gender"
                                                )}
                                            />
                                            <label htmlFor={`gender-female`}>
                                                Female
                                            </label>
                                        </div>
                                    </div>
                                </div>*/}

                                <TextInput
                                    ref={(input) =>
                                        (this.nordIdentifier = input)
                                    }
                                    className=""
                                    inputClassName=""
                                    label="NORD Member Identifier"
                                    type="text"
                                    onChange={this.onChange.bind(
                                        this,
                                        "nordIdentifier"
                                    )}
                                    value={this.state.nordIdentifier.value}
                                    valid={this.state.nordIdentifier.valid}
                                    validator={(val) => {
                                        return val.length > 1;
                                    }}
                                    error=""
                                />
                                <span className="row edit-member-warning">
                                    Editing Member details affects new PDF
                                    Generation ONLY. Does not affect Member
                                    information in other systems.
                                </span>

                                <Button
                                    color={"red"}
                                    flat={false}
                                    onClick={this.handleSubmit.bind(this)}
                                    z-depth={1}
                                >
                                    {"Update User"}
                                </Button>

                                <Button
                                    color={null}
                                    flat={true}
                                    onClick={(e) =>
                                        this.props.history.push(
                                            "/dashboard/search-member"
                                        )
                                    }
                                    z-depth={1}
                                >
                                    {"Back"}
                                </Button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
    };
}

export default connect(mapStateToProps)(EditMember);



// WEBPACK FOOTER //
// ./src/pages/Dashboard/EditMember/EditMember.js